<template>
  <v-row>
    <v-col cols="12">
      <div class="text-h6 font-weight-bold py-2">
        導入手順
      </div>
      <div class="text-body-1 px-5">
        Weedcraftに日本語化Modを導入する手順を例に説明します。
      </div>
      <v-timeline dense>
        <v-timeline-item  v-for="step in steps" :key="step.title">
          <v-card class="elevation-2">
            <v-card-title class="text-h6">
              {{step.title}}
            </v-card-title>
            <v-card-text class="text-body-1" v-html=step.text />
            <file-tree class="px-5 pb-5" v-if="step.fileInfo" :fileInfo="step.fileInfo"/>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-col>
  </v-row>
</template>

<script>
import FileTree from '@/components/FileTree.vue'

export default {
  components: {
    FileTree,
  },
  data(){
    return{
      steps:[
        {
          title: 'ダウンロード',
          text: 'リポジトリの<a href="https://github.com/BepInEx/BepInEx/releases" target="_blank">最新リリース</a>のAssetsのリストから、BepInExをダウンロードします。通常は64ビット版の[BepInEx_x64_X.X.XX.X.zip]をダウンロードしてください。',
          fileInfo: {
            initiallyOpen: ['BepInEx_x64_X.X.XX.X.zip'],
            files: {
              zip: 'mdi-archive',
              txt: 'mdi-file-document-outline',
              exe: 'mdi-microsoft-windows',
              dll: 'mdi-file-cog',
            },
            tree: [],
            items: [
              {
                name: 'BepInEx_x64_X.X.XX.X.zip',
                file: 'zip',
                children: [
                  {name: 'BepInEx',},
                  {name: 'changelog.txt',file: 'txt',},
                  {name: 'doorstop_config.ini',file: 'txt',},
                  {name: 'winhttp.dll',file: 'dll',},
                ]
              },
            ],
          }
        },
        {
          title: 'ファイルコピー',
          text: 'ファイルを解凍し、中にある<b>BepInExフォルダ</b>、<b>doorstop_config.ini</b>、<b>winhttp.dll</b>の3つをゲームの実行ファイルがあるフォルダにコピーします。',
          fileInfo: {
            initiallyOpen: ['Weedcraft','BepInEx'],
            files: {
              txt: 'mdi-file-document-outline',
              exe: 'mdi-leaf',
              dll: 'mdi-file-cog',
              unity: 'mdi-unity'
            },
            tree: [],
            items: [
              {
                name: 'Weedcraft',
                children: [
                  {name: 'BepInEx', children:[
                    {name: 'core', new: true},
                  ], new: true},
                  {name: 'Mono',},
                  {name: 'Weedcraft Inc_Data',},
                  {name: 'doorstop_config.ini',file: 'txt',new: true,},
                  {name: 'UnityCrashHandler64.exe',file: 'unity',},
                  {name: 'UnityPlayer.dll',file: 'dll',},
                  {name: 'Weedcraft Inc.exe',file: 'exe',},
                  {name: 'winhttp.dll',file: 'dll',new: true,},
                ],
              },
            ],
          }
        },
        {
          title: 'ゲームを起動',
          text: '一度ゲームを起動し、終了します。先ほどコピーしたBepInExフォルダを開き、core以外のフォルダが生成されていればBepInExの導入は完了です。',
          fileInfo: {
            initiallyOpen: ['Weedcraft','BepInEx'],
            files: {
              txt: 'mdi-file-document-outline',
              exe: 'mdi-leaf',
              dll: 'mdi-file-cog',
              unity: 'mdi-unity'
            },
            tree: [],
            items: [
              {
                name: 'Weedcraft',
                children: [
                  {
                    name: 'BepInEx',
                    children:[
                      {name: 'cache',new: true},
                      {name: 'config',new: true},
                      {name: 'core'},
                      {name: 'patchers',new: true},
                      {name: 'plugins',new: true},
                      {name: 'LogOutput.log',file: 'txt',new: true},
                    ]
                  },
                  {name: 'Mono',},
                  {name: 'Weedcraft Inc_Data',},
                  {name: 'doorstop_config.ini',file: 'txt',},
                  {name: 'UnityCrashHandler64.exe',file: 'unity',},
                  {name: 'UnityPlayer.dll',file: 'dll',},
                  {name: 'Weedcraft Inc.exe',file: 'exe',},
                  {name: 'winhttp.dll',file: 'dll',},
                ],
              },
            ],
          }
        },
        {
          title: 'Modの導入',
          text: '公開されてるModやプラグインをpluginsフォルダにコピーすることで、実行時にロードされModやプラグインが適用されます。',
          fileInfo: {
            initiallyOpen: ['Weedcraft','BepInEx','plugins','WeedctaftJpnMod'],
            files: {
              txt: 'mdi-file-document-outline',
              exe: 'mdi-leaf',
              dll: 'mdi-file-cog',
              file: 'mdi-file',
              unity: 'mdi-unity'
            },
            tree: [],
            items: [
              {
                name: 'Weedcraft',
                children: [
                  {
                    name: 'BepInEx',
                    children:[
                      {name: 'cache'},
                      {name: 'config'},
                      {name: 'core'},
                      {name: 'patchers'},
                      {
                        name: 'plugins',
                        children: [
                          {
                            name: 'WeedctaftJpnMod',new: true,
                            children: [
                              {name: 'config.json', file: 'txt',new: true},
                              {name: 'IBMPlexSansJP-Medium', file: 'file',new: true},
                              {name: 'IBMPlexSansJP-Medium SDF', file: 'file',new: true},
                              {name: 'weedcraft.tsv', file: 'txt',new: true},
                              {name: 'WeedctaftJpnMod.dll', file: 'dll',new: true},
                            ]
                          }
                        ]},
                      {name: 'LogOutput.log',file: 'txt'},
                    ]
                  },
                  {name: 'Mono',},
                  {name: 'Weedcraft Inc_Data',},
                  {name: 'doorstop_config.ini',file: 'txt',},
                  {name: 'UnityCrashHandler64.exe',file: 'unity',},
                  {name: 'UnityPlayer.dll',file: 'dll',},
                  {name: 'Weedcraft Inc.exe',file: 'exe',},
                  {name: 'winhttp.dll',file: 'dll',},
                ],
              },
            ],
          }          
        }
      ],
    }
  }
};
</script>
